import { S3_BASE_URL } from 'constants/static';
import styled from 'styled-components';
import { useTranslation } from 'i18n';

const FooterContainer = styled.footer`
  width: 100%;
  min-height: 129px;
  background-color: #002400;
  padding: 30px 20px;
  flex-direction: column;
  margin-top: auto; /* Footer를 하단에 고정 */
  box-sizing: border-box;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  img {
    width: 87px;
    height: 16px; /* 적절한 로고 크기 */
    object-fit: contain;
  }
`;

const CopyrightText = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  font-weight: 400;
  margin-bottom: 5px;
`;

const LinksContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const FooterLink = styled.a`
  font-size: 12px;
  color: #ffffff;
  text-decoration: none;
  line-height: 16px;
  font-weight: 400;

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

const Divider = styled.span`
  color: #ffffff;
  opacity: 0.5;
  font-size: 12px;
`;

export function FooterLayout() {
  const { t } = useTranslation();
  return (
    <FooterContainer>
      <LogoSection>
        <img src={`${S3_BASE_URL}/kaddie_new_footer_logo.svg`} alt="kaddie footer logo" />
      </LogoSection>

      <CopyrightText>{t('footer.copyright')}</CopyrightText>

      <LinksContainer>
        <FooterLink
          href="https://kimcaddie.notion.site/kaddie-privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.privacy_policy')}
        </FooterLink>
        <Divider>|</Divider>
        <FooterLink
          href="https://kimcaddie.notion.site/kaddie-terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.terms_of_use')}
        </FooterLink>
      </LinksContainer>
    </FooterContainer>
  );
}
